<div class="date-filter-container mb-0" *ngIf="showDateFilter">
  <div class="date-filter-header">
    <div class="date-nav-with-label">
      <button type="button" class="btn date-nav-btn" (click)="decrementDate()" rippleEffect>
        <i data-feather="chevron-left"></i>
      </button>
      <button type="button" class="btn date-nav-btn" (click)="incrementDate()" rippleEffect>
        <i data-feather="chevron-right"></i>
      </button>
      <p class="date-display">{{ selectedPeriod || '' }}</p>
    </div>
  </div>
  <div class="date-filter-buttons">
    <div class="btn-group" role="group">
      <button
        type="button"
        class="btn bouttons"
        rippleEffect
        (click)="changeViewMode('jours')"
        [class.active]="viewMode === 'jours'"
      >
        <p>Jours</p>
      </button>
      <button
        type="button"
        class="btn bouttons"
        rippleEffect
        (click)="changeViewMode('mois')"
        [class.active]="viewMode === 'mois'"
      >
        <p>Mois</p>
      </button>
      <button
        type="button"
        class="btn bouttons"
        rippleEffect
        (click)="changeViewMode('annees')"
        [class.active]="viewMode === 'annees'"
      >
        <p>Année</p>
      </button>
      <button
        class="btn bouttons"
        rippleEffect
        (click)="openFlatpickr(); $event.preventDefault()"
        style="color: rgba(19, 74, 211, 1);"
      >
        <i data-feather="calendar"></i>
      </button>
    </div>
    <input type="text" #datePicker class="flatpickr-input" style="margin-top: 40px;" />
  </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="showDateFilter && viewMode === 'jours'">
  <div class="data-list-wrapper">
    <div
      *ngFor="let day of weekDays"
      (click)="selectDay(day)"
      [class.selected]="day.dateString === selectedDay"
      [class.today]="day.isToday"
      class="day-item"
    >
      {{ day.label }}
    </div>
  </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="showDateFilter && viewMode === 'mois'">
  <div class="data-list-wrapper">
    <div
      *ngFor="let month of months; let i = index"
      (click)="selectMonth(i)"
      [class.selected]="i === selectedMonthIndex"
      [class.today]="i === currentMonthIndex"
      class="month-item"
    >
      {{ month }}
    </div>
  </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="showDateFilter && viewMode === 'annees'">
  <div class="data-list-wrapper">
    <div
      *ngFor="let year of years"
      (click)="selectYear(year)"
      [class.selected]="year === selectedYear"
      [class.today]="year === currentYear"
      class="year-item"
    >
      {{ year }}
    </div>
  </div>
</div>

<div class="d-flex" style="position: relative;">
  <div class="card-body row m-0 align-items-center flex-wrap" style="padding: 24px">
    <div class="input-group form-password-toggle d-flex" style="width: 300px;">
      <input
        type="text"
        class="form-control"
        [placeholder]="searchPlaceholder"
        aria-label="Recherche"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearch()"
      />
      <div class="input-group-append" style="margin-right: 10px;">
        <span class="input-group-text" style="color: black;">
          <i data-feather="search" [size]="20"></i>
        </span>
      </div>
    </div>

    <ng-select
      *ngIf="showWarehouseFilter"
      [id]="warehouseSelectId"
      class="filter-ng-select pos-toolbar-ng-select flex-shrink-0"
      [items]="warehouseOptions"
      bindLabel="label"
      bindValue="id"
      [multiple]="true"
      [clearable]="true"
      [searchable]="true"
      [placeholder]="warehousePlaceholder"
      [(ngModel)]="selectedWarehouseIds"
      (change)="onWarehouseFilterChange()"
      [closeOnSelect]="false"
      appendTo="body"
    >
    </ng-select>

    <div
      class="active-filters-container d-flex flex-wrap align-items-center gap-2"
      style="margin-left: 12px;"
      *ngIf="getActiveFilters().length > 0"
    >
      <div *ngFor="let filter of getActiveFilters(); trackBy: trackByFilterKey" class="filter-badge">
        <span class="filter-badge-label">{{ filter.label }}:</span>
        <span class="filter-badge-value">{{ filter.value }}</span>
        <button
          type="button"
          class="filter-badge-close"
          (click)="removeFilter(filter.key, $event); $event.stopPropagation(); $event.preventDefault()"
          aria-label="Supprimer le filtre"
        >
          <i data-feather="x" style="width: 12px; height: 12px;"></i>
        </button>
      </div>
    </div>
  </div>
</div>
